/* eslint no-console: 0 */
/* global axios */
import ApiClient from '../ApiClient';

export const buildCreatePayload = ({
  message,
  isPrivate,
  contentAttributes,
  echoId,
  files,
  ccEmails = '',
  bccEmails = '',
  toEmails = '',
  templateParams,
  cannedResponseId,
  cannedBlobIds,
}) => {
  let payload;
  if (files && files.length !== 0) {
    payload = new FormData();
    if (message) {
      payload.append('content', message);
    }
    files.forEach(file => {
      payload.append('attachments[]', file);
    });
    payload.append('private', isPrivate);
    payload.append('echo_id', echoId);
    payload.append('cc_emails', ccEmails);
    payload.append('bcc_emails', bccEmails);

    if (toEmails) {
      payload.append('to_emails', toEmails);
    }
    if (contentAttributes) {
      payload.append('content_attributes', JSON.stringify(contentAttributes));
    }
    if (cannedResponseId) {
      payload.append('canned_response_id', cannedResponseId);
    }
    if (cannedBlobIds && cannedBlobIds.length) {
      cannedBlobIds.forEach(blobId => {
        payload.append('canned_blob_ids[]', blobId);
      });
    }
  } else {
    payload = {
      content: message,
      private: isPrivate,
      echo_id: echoId,
      content_attributes: contentAttributes,
      cc_emails: ccEmails,
      bcc_emails: bccEmails,
      to_emails: toEmails,
      template_params: templateParams,
    };
    if (cannedResponseId) {
      payload.canned_response_id = cannedResponseId;
    }
    if (cannedBlobIds && cannedBlobIds.length) {
      payload.canned_blob_ids = cannedBlobIds;
    }
  }
  return payload;
};

class MessageApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create({
    conversationId,
    message,
    private: isPrivate,
    contentAttributes,
    echo_id: echoId,
    files,
    ccEmails = '',
    bccEmails = '',
    toEmails = '',
    templateParams,
    cannedResponseId,
    cannedBlobIds,
  }) {
    return axios({
      method: 'post',
      url: `${this.url}/${conversationId}/messages`,
      data: buildCreatePayload({
        message,
        isPrivate,
        contentAttributes,
        echoId,
        files,
        ccEmails,
        bccEmails,
        toEmails,
        templateParams,
        cannedResponseId,
        cannedBlobIds,
      }),
    });
  }

  delete(conversationID, messageId) {
    return axios.delete(`${this.url}/${conversationID}/messages/${messageId}`);
  }

  // Editar mensagem (Helevor/Uazapi): propaga o edit pro WhatsApp do cliente.
  edit(conversationID, messageId, content) {
    return axios.post(
      `${this.url}/${conversationID}/messages/${messageId}/edit`,
      { content }
    );
  }

  // Reagir com emoji (Helevor/Uazapi): propaga a reacao pro WhatsApp do cliente.
  // Emoji vazio remove a reacao.
  react(conversationID, messageId, emoji) {
    return axios.post(
      `${this.url}/${conversationID}/messages/${messageId}/react`,
      { emoji }
    );
  }

  retry(conversationID, messageId) {
    return axios.post(
      `${this.url}/${conversationID}/messages/${messageId}/retry`
    );
  }

  getPreviousMessages({ conversationId, after, before }) {
    const params = { before };
    if (after && Number(after) !== Number(before)) {
      params.after = after;
    }
    return axios.get(`${this.url}/${conversationId}/messages`, { params });
  }

  translateMessage(conversationId, messageId, targetLanguage) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/translate`,
      {
        target_language: targetLanguage,
      }
    );
  }
}

export default new MessageApi();
